import FeatherIcon from 'feather-icons-react';
import React from 'react'
import { useTranslation } from 'react-i18next';
import '../sass/displayUnitEdit.scss';

const EmptyDisplay = ({
    isRTL,
    dmode
}) => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            <div className="du-empty-box">
               <div className="d-flex flex-column align-items-center">
                <FeatherIcon icon="move" className="empty-box-icon" size={16}/>
                <span className="empty-box-message">{t('EMPTY_MESSAGE')}</span>
               </div>
            </div>
        </React.Fragment>
    )
}
        

export default EmptyDisplay;